<div class="manage-items-container p-3">
	<mat-card class="p-4 h-100">
		<mat-card-header>
			<mat-card-title class="d-flex justify-content-between align-items-start w-100">
				<app-nav-map [load]="itemType"> </app-nav-map>
				@if (itemTypeWithScope) {
				<span class="me-auto ms-1 info">({{ itemType + '.' + itemTypeWithScope | uppercase | translate }})</span>
				} @if (itemType !== 'TAG') {
				<button mat-flat-button color="primary" class="d-flex justify-content-center align-items-center" (click)="itemAction('NEW')">
					{{ 'BUTTON.CREATE' | translate }} {{ itemType + '.TITLE' | translate }}
				</button>
				}
			</mat-card-title>
		</mat-card-header>

		<mat-card-content>
			<mat-divider class="w-75 mb-4"></mat-divider>

			<div class="row">
				<div class="col-4">
					<mat-form-field class="w-100 pb-2" appearance="outline">
						<mat-label>{{ 'BUTTON.SEARCH' | translate }}</mat-label>
						<input matInput type="text" [formControl]="searchFormControl" />
						<mat-icon class="cursor-pointer" matSuffix (click)="search()">search</mat-icon>
					</mat-form-field>
				</div>
				@if (itemTypeWithScope === 'medium_clipping') {
				<div class="col-3">
					<mat-form-field class="w-100 pb-2" appearance="outline">
						<mat-label>{{ 'CLIPS.MEDIUM_TYPE' | translate }}</mat-label>
						<select id="types" style="display: none"></select>
						<!-- workaround for material-chrome bug -->
						<mat-select [formControl]="mediumTypeFormControl" multiple>
							<mat-option #selectAllMediumTypes value="ALL" (click)="mediumTypeSelection()">{{ 'MEDIUM.TYPES.ALL' | translate }}</mat-option>
							
							@for (clipType of clipTypes; track clipType.id) {
							<mat-option [value]="clipType.id" (click)="mediumTypeSelection($event)">
								{{ 'MEDIUM.TYPES.' + clipType.id | translate }}
							</mat-option>
							}
						</mat-select>
					</mat-form-field>
				</div>
				<div class="col-3">
					<mat-form-field class="w-100 pb-2" appearance="outline">
						<mat-label>{{ 'MEDIUM.LANGUAGE' | translate }}</mat-label>
						<select id="languages" style="display: none"></select>
						<!-- workaround for material-chrome bug -->
						<mat-select [formControl]="mediumLangFormControl" multiple>
							@for (lang of langOptions; track getLangCode(lang)) {
							<mat-option [value]="getLangCode(lang)">{{ lang.name | translate }}</mat-option>
							}
						</mat-select>
					</mat-form-field>
				</div>
				}

				<!-- Alphabets for searching for Author and Medium -->
				<!-- @if(itemType === 'AUTHOR' || itemType === 'MEDIUM') {
				<div class="col">
					<ul class="alphabet-list d-flex flex-wrap justify-content-between align-items-end px-4">
						@for (letter of englishAlphabet; track $index) {
						<span [ngClass]="{ selected: activatedLetter === letter }" (click)="getDataByLetter(letter, 'latin')">{{ letter }}</span>
						<span class="separator">|</span>
						}
					</ul>
					<ul class="alphabet-list d-flex flex-wrap justify-content-between align-items-end px-4">
						@for (letter of macedonianAlphabet; track $index) {
						<span [ngClass]="{ selected: activatedLetter === letter }" (click)="getDataByLetter(letter, 'cyrillic')">{{ letter }}</span>
						<span class="separator">|</span>
						}
					</ul>
				</div>
				} -->
				<!-- (END)Alphabets for searching for Author and Medium -->
			</div>

			@if (itemType === 'KEYWORD') {
			<div class="row">
				<div class="col-4">
					<span class="mb-1 d-block">{{ 'KEYWORD.FILTER_BY_TAGS' | translate }}</span>
					<mat-accordion #keywordTagsFilterAccordion="matAccordion" multi>
						@for (category of keywordTagCategories; track category.id) {
						<mat-expansion-panel>
							<mat-expansion-panel-header>
								<mat-panel-title>
									{{ utils.getParameterByName(category, 'value') }}
								</mat-panel-title>
							</mat-expansion-panel-header>
							<div class="d-flex flex-column p-1">
								@for (tag of utils.getParameterByName(category, 'tags'); track tag.id) {
								<mat-checkbox [checked]="selectedKeywordTagIds.includes(tag.id)" (change)="toggleKeywordTagFilter($event, tag.id)">
									{{ tag.value }}
								</mat-checkbox>
								}
							</div>
						</mat-expansion-panel>
						}
					</mat-accordion>
				</div>
				<div class="col-3">
					<span class="mb-1 d-block">{{ 'KEYWORD.FILTER_BY_SOURCES' | translate }}</span>
					<div class="d-flex flex-column">
						@for (source of keywordSources; track source) {
						<mat-checkbox [checked]="selectedKeywordSources.includes(source)" (change)="toggleKeywordSourceFilter($event, source)">{{ source }}</mat-checkbox>
						}
					</div>
				</div>
				<div class="col-2 d-flex align-items-start pt-4">
					<button mat-stroked-button color="primary" (click)="clearKeywordFilters()">
						{{ 'BUTTON.CLEAR_FILTERS' | translate }}
					</button>
				</div>
			</div>
			}

			<!-- <mat-divider class="w-75 my-4"></mat-divider> -->

			@if (searchedTerm || activatedLetter) {
			<span class="mb-2">{{ 'ASSORTED.SHOWING_RESULTS_FOR' | translate }}: {{ searchedTerm || activatedLetter }} ( {{ foundResults }} )</span>
			} @if(itemType === 'AUTHOR' || itemType === 'MEDIUM' || itemType === 'BUSINESS_ENTITY') {
			<mat-card class="mat-elevation-z8 list-content-wrapper">
				<mat-card-content>
					<div class="d-flex gap-2 flex-wrap p-2">
						@for (item of items; track $index ) {
						<!-- Preview for Authors, Mediums, Business Entity -->
						<div
							[style.background-color]="utils.getParameterByName(item, 'color')"
							[style.padding]="displayDeleteIcon === item.id ? '5px' : '5px 20px'"
							class="d-flex align-items-center list-item"
							(mouseenter)="displayDeleteIcon = item.id || ''"
							(mouseleave)="displayDeleteIcon = ''">
							<span [style.opacity]="displayDeleteIcon === item.id ? '1' : '0.7'" (click)="itemAction('EDIT', item)">
								{{ utils.getParameterByLanguageScript(item, 'name', itemType === 'BUSINESS_ENTITY') }}
								{{ itemType === 'MEDIUM' ? '(' + ('MEDIUM.TYPES.' + utils.getParameterByName(item, 'type') | translate) + ')' : '' }}
							</span>

							<div [@showHide]="displayDeleteIcon === item.id ? 'show' : 'hide'">
								<button
									mat-icon-button
									color="warn"
									aria-label="Delete data item"
									matTooltip="{{ 'BUTTON.DELETE' | translate }}"
									matTooltipPosition="below"
									(click)="itemAction('DELETE', item)">
									<mat-icon>close</mat-icon>
								</button>
							</div>
						</div>
						}
					</div>
				</mat-card-content>
			</mat-card>

			@if(!searchedTerm) {
			<div class="row">
				<mat-paginator [pageSizeOptions]="pageOptions" [pageSize]="pageOptions[0]" (page)="search()" showFirstLastButtons aria-label="Select page of items"> </mat-paginator>
			</div>
			}
			<!-- (END)Preview for Authors, Mediums, Business Entity -->
			} @else if(itemType === 'TAG') {<!-- Preview for Categories and Tags -->
			<mat-card class="mat-elevation-z8 list-content-wrapper p-2">
				<button mat-flat-button color="primary" class="ms-auto mb-1" (click)="itemAction('NEW', undefined, 'CATEGORY')">
					{{ 'BUTTON.CREATE' | translate }} {{ 'CATEGORY.TITLE' | translate }}
				</button>

				<mat-accordion #tagsAccordion="matAccordion" multi>
					@for (item of items; track $index ) {
					<mat-expansion-panel
						(opened)="accordionAction('open', utils.suppressType(item))"
						(closed)="accordionAction('close', utils.suppressType(item))"
						[expanded]="utils.suppressType(item).isOpened">
						<mat-expansion-panel-header>
							<mat-panel-title>
								<span>
									{{ utils.getParameterByName(item, 'value') }}
								</span>
							</mat-panel-title>
							<mat-panel-description>
								<button
									class="ms-auto"
									mat-icon-button
									color="primary"
									aria-label="Create data item"
									matTooltip="{{ itemType + '.CREATE_TAG' | translate }}"
									matTooltipPosition="below"
									(click)="itemAction('NEW', item)">
									<mat-icon>add</mat-icon>
								</button>
								<button
									mat-icon-button
									color="primary"
									aria-label="Edit data item"
									matTooltip="{{ 'BUTTON.EDIT' | translate }}"
									matTooltipPosition="below"
									(click)="itemAction('EDIT', item, 'CATEGORY')">
									<mat-icon>edit</mat-icon>
								</button>
								<button
									mat-icon-button
									color="warn"
									aria-label="Delete data item"
									matTooltip="{{ 'BUTTON.DELETE' | translate }}"
									matTooltipPosition="below"
									(click)="itemAction('DELETE', item, 'CATEGORY')">
									<mat-icon>close</mat-icon>
								</button>
							</mat-panel-description>
						</mat-expansion-panel-header>

						<div class="d-flex gap-2 flex-row flex-wrap p-2">
							@for (tag of utils.getParameterByName(item, 'tags'); track $index ) {
							<div
								[style.background-color]="utils.getParameterByName(tag, 'colorCode')"
								[style.padding]="displayDeleteIcon === tag.id ? '5px' : '5px 20px'"
								class="tag-item d-flex align-items-center list-item"
								(mouseenter)="displayDeleteIcon = tag.id || ''"
								(mouseleave)="displayDeleteIcon = ''">
								<span [style.opacity]="displayDeleteIcon === tag.id ? '1' : '0.7'" (click)="itemAction('EDIT', tag)">
									{{ utils.getParameterByName(tag, 'value') }}
								</span>
								<div [@showHide]="displayDeleteIcon === tag.id ? 'show' : 'hide'">
									<button
										mat-icon-button
										color="warn"
										aria-label="Delete data item"
										matTooltip="{{ 'BUTTON.DELETE' | translate }}"
										matTooltipPosition="below"
										(click)="itemAction('DELETE', tag)">
										<mat-icon>close</mat-icon>
									</button>
								</div>
							</div>
							}
						</div>
					</mat-expansion-panel>
					}
				</mat-accordion>
			</mat-card>
			<!-- (END)Preview for Categories and Tags -->
			} @else if (itemType === 'KEYWORD') {
			@if (selectedKeywordTagIds.length > 0 || selectedKeywordSources.length > 0) {
			<span class="mb-2 d-block">{{ 'KEYWORD.SHOWING_FILTERED_COUNT' | translate }}: {{ dataSource.data.length }} / {{ items.length }}</span>
			}
			<mat-card class="mat-elevation-z8 list-content-wrapper">
				<mat-card-content>
					<div class="mat-elevation-z2 px-0">
						<table mat-table [dataSource]="dataSource">
							@for (column of displayedColumns; track $index) {
							<ng-container [matColumnDef]="column">
								<th mat-header-cell *matHeaderCellDef>
									{{ 'KEYWORD.' + column | translate }}
								</th>
								<td mat-cell *matCellDef="let element" class="cursor-pointer" (click)="itemAction('EDIT', element)">
									@if(column === 'TAGS') {
									<div class="d-flex justify-content-between">
										<div class="d-flex flex-row flex-wrap">
											@for(tag of element[column.toLowerCase()]; track $index) {
											<div [style.background-color]="utils.getParameterByName(tag, 'colorCode')" class="tag-item d-flex align-items-center list-item me-1">
												<span>
													{{ utils.getParameterByName(tag, 'value') }}
												</span>
											</div>
											}
										</div>

										<div class="d-flex gap-1">
											<button
												mat-icon-button
												aria-label="Seach for keyword"
												matTooltip="{{ 'BUTTON.SEARCH' | translate }}"
												matTooltipPosition="below"
												(click)="searchForOneKeyword(element.id); $event.stopPropagation()">
												<mat-icon>manage_search</mat-icon>
											</button>

											<button
												mat-icon-button
												color="warn"
												aria-label="Deactivate data item"
												matTooltip="{{ 'BUTTON.DELETE' | translate }}"
												matTooltipPosition="below"
												(click)="itemAction('DELETE', element)">
												<mat-icon>close</mat-icon>
											</button>
										</div>
									</div>
									} @else {
									{{ element[column.toLowerCase()] }}
									}
								</td>
							</ng-container>
							}
							<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
							<tr mat-row *matRowDef="let row; columns: displayedColumns" matTooltip="{{ 'ASSORTED.CLICK_TO_EDIT' | translate }}" matTooltipPosition="below"></tr>
						</table>
					</div>
				</mat-card-content>
			</mat-card>
			}
		</mat-card-content>
	</mat-card>
</div>
